import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '处理逻辑',
    type: 'BDLOGIC_DD',
}
